import { render, staticRenderFns } from "./MenuIntro.vue?vue&type=template&id=2c708acc&scoped=true&"
import script from "./MenuIntro.vue?vue&type=script&lang=js&"
export * from "./MenuIntro.vue?vue&type=script&lang=js&"
import style0 from "./MenuIntro.vue?vue&type=style&index=0&id=2c708acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c708acc",
  null
  
)

export default component.exports